<!-- @format -->

<template>
	<div class="disabled-text">
		<template v-if="showValue[0]">
			<div v-if="Array.isArray(showValue[1])">
				<template v-for="(itm, _index) in showValue[1]" :key="_index">
					<el-tag
						v-if="itm.label"
						class="disabled-tag"
						v-bind="itm.pcProps"
						:type="itm.fontColor && colors[itm.fontColor] ? colors[itm.fontColor] : 'primary'"
						@click="emits('on-click', itm)"
					>
						{{ itm.label }}
					</el-tag>
				</template>
			</div>
			<el-tag
				v-else-if="showValue[1].label"
				class="disabled-tag"
				v-bind="showValue[1].pcProps"
				:type="showValue[1].fontColor && colors[showValue[1].fontColor] ? colors[showValue[1].fontColor] : 'primary'"
				@click="emits('on-click', showValue[1])"
			>
				{{ showValue[1].label }}
			</el-tag>
		</template>
		<span v-else @click="emits('on-click', showValue[1])">{{ showValue[1].label }}</span>
	</div>
</template>

<script setup lang="ts">
	import { deepClone } from '@/utils';

	interface Props {
		value: string | number | string[];
		params?: {
			label: string;
			value: string;
			children?: Props['params'];
			pcProps?: any;
		}[];
		showTag?: boolean;
	}
	const colors = {
		'#606266': 'primary',
		'#409EFF': 'primary',
		'#67C23A': 'success',
		'#909399': 'info',
		'#E6A23C': 'warning',
		'#F56C6C': 'danger',
	};

	const props = withDefaults(defineProps<Props>(), {
		value: '',
	});

	const emits = defineEmits(['on-click']);

	const getValue = (value: string | number | (string | number)[], params: Props['params']) => {
		if (Array.isArray(value)) {
			if (value.length > 1) {
				const vals = deepClone(value) as typeof value;
				const item = params?.find((it) => it.value === vals!.shift());

				return { label: `${item?.label}/${getValue(vals, item?.children || []).label}` };
			} else {
				return params?.find((it) => it.value === value[0]) || {};
			}
		}

		return params?.find((it) => it.value === value) || {};
	};

	const showValue = computed(() => {
		if (props.params) {
			if (Array.isArray(props.value)) {
				return [true, props.value.map((itm) => getValue(itm, props.params))];
			} else {
				console.log(getValue(props.value, props.params));

				return [true, getValue(props.value, props.params)];
			}
		} else {
			return [props.showTag, { label: props.value }];
		}
	});
</script>

<style scoped lang="scss">
	.disabled-text {
		width: 100%;
		// overflow: hidden;
		// text-overflow: ellipsis;
		// white-space: nowrap;
		white-space: inherit;
		overflow: inherit;
		text-overflow: inherit;

		.disabled-tag {
			max-width: 100%;

			:deep(.el-tag__content) {
				width: 100%;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}
		}

		.disabled-tag + .disabled-tag {
			margin-left: 3px;
		}
	}
</style>
